var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCheckbox',{attrs:{"input-value":_vm.value,"label":_vm.label},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }